import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 24px;
  width: 100%;
  max-width: 420px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  border-radius: 24px 24px 0 0;
  position: sticky;
  top: 0;
  z-index: 10;
  
  h3 {
    margin: 0;
    color: white;
    font-size: 16px;
    font-weight: 700;
  }
  
  p {
    margin: 6px 0 0 0;
    color: rgba(255, 255, 255, 0.8);
    font-size: 13px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
`;

export const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
`;

export const OptionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
`;

export const ArcadaOption = styled.button<{ selected: boolean }>`
  padding: 16px 12px;
  border: 2px solid ${props => props.selected ? '#8b5cf6' : '#e2e8f0'};
  border-radius: 14px;
  background: ${props => props.selected ? 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)' : 'white'};
  color: ${props => props.selected ? '#6d28d9' : '#475569'};
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  
  &:hover {
    border-color: #8b5cf6;
  }
  
  &:active {
    transform: scale(0.97);
  }
  
  .label {
    font-size: 13px;
    font-weight: 600;
  }
  
  .icon {
    font-size: 24px;
  }
`;

export const TotalPreview = styled.div`
  text-align: center;
  padding: 12px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-radius: 12px;
  margin-top: 8px;
  
  .count {
    font-size: 14px;
    font-weight: 600;
    color: #166534;
  }
  
  .total {
    font-size: 18px;
    font-weight: 700;
    color: #7c3aed;
    margin-top: 4px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #e2e8f0;
  position: sticky;
  bottom: 0;
  background: white;
  border-radius: 0 0 24px 24px;
`;

export const FooterButton = styled.button<{ variant?: 'primary' | 'secondary' }>`
  flex: 1;
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  ${props => props.variant === 'primary' ? `
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
    border: none;
    color: white;
    
    &:disabled {
      background: #94a3b8;
    }
  ` : `
    background: white;
    border: 2px solid #e2e8f0;
    color: #475569;
    
    &:hover {
      border-color: #8b5cf6;
      color: #8b5cf6;
    }
  `}
`;
